import React from "react"
import { withRouter } from 'react-router-dom'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { AuthContext } from '../../main/ProvedorAutenticacao'
import ReactToPrint from "react-to-print";

import './documentos.css'

class ComponentToPrintProcuracaoAdJudicia extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      dataImpressao: ''
    }
  }

  componentDidMount() {
    var monName = new Array ("janeiro", "fevereiro", "março", "abril", "Maio", "junho", "agosto", "outubro", "novembro", "dezembro")
    var data = new Date();
    var dataCompleta = "João Pessoa, " + data.getDate () + " de " + monName [data.getMonth() ]   +  " de "  +     data.getFullYear ()
    this.setState({dataImpressao: dataCompleta});
  }

  render() {
    return(
      <>
        <div>
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <div style={{textAlign: 'center'}} className="titulo2">
            <h3><strong>PROCURAÇÃO AD JUDICIA</strong></h3>
          </div>
          <br></br>
          <div>
              <div style={{textAlign: 'LEFT'}}>
                <p className="kleiton">
                  <h4>
                    <hr></hr>
                    <strong>OUTORGANTE</strong>
                    <hr></hr>
                  </h4>
                  <br/>
                  <h4>
                    {this.props.nomePessoa}, {this.props.nacionalidade}, {this.props.estadoCivil}, {this.props.profissao}, identidade nº. {this.props.rg}, CPF nº.: {this.props.cpf}, 
                    residente e domiciliado na Rua {this.props.endereco}, nº. {this.props.numero}, {this.props.bairro}, {this.props.cidade} - {this.props.estado}, CEP: {this.props.cep}.
                  </h4>
                  <br/>
                  <h4>
                    <hr></hr>
                      <strong>OUTORGADO(S)</strong>
                    <hr></hr>
                  </h4>
                  <br/>
                  <h4>
                    <strong>RODRIGO MAGNO NUNES MORAES</strong>, brasileiro, casado, advogado, inscrito na OAB/PB sob o nº 14798, inscrito no CPF/MF sob nº 057.010.604-46 
                    e <strong>ANNE KARINE RODRIGUES MORAES</strong>, brasileira, casada, advogada, inscrita na OAB/PB sob o nº 23.573, 
                    ambos com endereço profissional na Avenida João Machado, nº553, Sala 617, 6º andar, 
                    Empresarial Plaza Center, Centro, João Pessoa – Paraíba, CEP 58.013-520, e-mail: rm_advogados@hotmail.com.
                  </h4>
                  <br/>
                  <h4>
                    <hr></hr>
                      <strong>PODERES</strong>
                    <hr></hr>
                  </h4>
                  <br/>
                  <h4>
                  Concedendo-lhes os poderes da cláusula ad judicia et extra, para o foro em geral, podendo, propor ações em 
                  nome da outorgante e defendê-las nas que figure como ré, reclamada, assistente, oponente ou de qualquer 
                  forma interessado, recebendo inclusive notificações e informativos, na esfera municipal, estadual, federal, 
                  na área cível, eleitoral, trabalhista ou penal, inclusive em procedimentos administrativos ou correcionais, 
                  podendo recorrer para qualquer instância ou Tribunal, conferindo-lhe, ainda, poderes para confessar, desistir, 
                  transigir, firmar compromissos ou acordos, renunciar aos valores que ultrapassaram o teto delimitador da competência 
                  dos Juizados Federais e Estaduais, receber valores e dar quitação, firmar compromisso, pedir a justiça gratuita e 
                  assinar declaração de hipossuficiência econômica (Em conformidade com a norma do art. 105 do NCPC15), suscitar 
                  incidentes de falsidade, agravar regimentalmente, levantar exceções de impedimento e suspeição, receber alvarás 
                  junto ao Banco do Brasil e Caixa Econômica Federal, podendo ainda substabelecer com ou sem reserva de poderes, 
                  assinar termos de caução real ou fidejussória, concordar, discordar, enfim tudo mais praticar para o fiel e cabal 
                  desempenho deste mandato que lhes é conferido.  
                  </h4>
                  <br/>
                  <h4 style={{textAlign: 'center'}}>
                    <strong>DECLARAÇÃO DE HIPOSSUFICIÊNCIA</strong>
                  </h4>
                  <br/>
                  <h4>
                    <hr></hr>
                      Declaro que, em função de minha condição financeira, não tenho condições de arcar com o pagamento das 
                      custas processuais, sob pena de implicar em prejuízo próprio e de minha família, nos termos do art. 5º, 
                      LXXIV, da Constituição da República e da Lei nº 1.060/50.
                    <hr></hr>
                  </h4>
                  <br></br>
                  <br></br>
                  <h4 className="data">
                    <strong>{this.state.dataImpressao}</strong>
                  </h4>
                  <br></br>
                  <br></br>
                  <h4 className="data">
                     _______________________________________
                    <br/>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{this.props.nomePessoa}
                  </h4>
                  <br></br>
                  <br></br>
                </p>
              </div>
          </div>
          <br/>
          <br/>
          <div>
          </div>
        </div>
      </>
    );
  }
}

class ProcuracaoAdJudicia extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      nomePessoa: '',
      nacionalidade: '',
      estadoCivil: '',
      profissao: '',
      rg: '',
      cpf: '',
      endereco: '',
      numero: '',
      bairro: '',
      cidade: '',
      estado: '',
      cep: ''
    }
  }

  componentDidMount() {
    const params = this.props.match.params;
    this.setState({nomePessoa: params.nomePessoa});
    this.setState({nacionalidade: params.nacionalidade});
    this.setState({estadoCivil: params.estadoCivil});
    this.setState({profissao: params.profissao});
    this.setState({rg: params.rg});
    this.setState({cpf: params.cpf});
    this.setState({endereco: params.endereco});
    this.setState({numero: params.numero});
    this.setState({bairro: params.bairro});
    this.setState({cidade: params.cidade});
    this.setState({estado: params.estado});
    this.setState({cep: params.cep});
  }

  render() {
    return (
      <div style={{textAlign: 'center'}}>
        <br></br>
        <br></br>
        <br></br>
        <ReactToPrint
          trigger={() => <a className="cursor" >Imprimir</a>}
          content={() => this.componentRef}>
        </ReactToPrint>
        <ComponentToPrintProcuracaoAdJudicia nomePessoa={this.state.nomePessoa}
                  nacionalidade={this.state.nacionalidade}
                  estadoCivil={this.state.estadoCivil}
                  profissao={this.state.profissao}
                  rg={this.state.rg}
                  cpf={this.state.cpf}
                  endereco={this.state.endereco}
                  numero={this.state.numero}
                  bairro={this.state.bairro}
                  cidade={this.state.cidade}
                  estado={this.state.estado}
                  cep={this.state.cep}
                ref={el => (this.componentRef = el)} />
      </div>
    );
  }
}

ProcuracaoAdJudicia.contextType = AuthContext;
export default ProcuracaoAdJudicia;